import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useLenis } from "@/hooks/useLenis";
import { Scene3D } from "@/components/3d/Scene3D";
import { Nav } from "@/components/landing/Nav";
import { Hero } from "@/components/landing/Hero";
import { Marquee } from "@/components/landing/Marquee";
import { About } from "@/components/landing/About";
import { Services } from "@/components/landing/Services";
import { EarthShowcase } from "@/components/landing/EarthShowcase";
import { WhyUs } from "@/components/landing/WhyUs";
import { Industries } from "@/components/landing/Industries";
import { Markets } from "@/components/landing/Markets";
import { SupplyChain } from "@/components/landing/SupplyChain";
import { Advantages } from "@/components/landing/Advantages";
import { Vision } from "@/components/landing/Vision";
import { ESG } from "@/components/landing/ESG";
import { Chairman } from "@/components/landing/Chairman";
import { Contact } from "@/components/landing/Contact";
import { Footer } from "@/components/landing/Footer";

const Landing = () => {
    useLenis();
    return (
        <div
            data-testid="landing-page"
            className="relative min-h-screen bg-[#0B0807] text-white"
        >
            <Scene3D />
            <Nav />
            <main className="relative z-10">
                <Hero />
                <Marquee />
                <About />
                <Services />
                <EarthShowcase />
                <WhyUs />
                <Industries />
                <Markets />
                <SupplyChain />
                <Advantages />
                <Vision />
                <ESG />
                <Chairman />
                <Contact />
            </main>
            <div className="relative z-10">
                <Footer />
            </div>
        </div>
    );
};

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<Landing />} />
                </Routes>
            </BrowserRouter>
        </div>
    );
}

export default App;
